const LangEnglishUKFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
    <rect width="16" height="11" fill="#012169" />
    <path d="M0 0L16 11M16 0L0 11" stroke="white" strokeWidth="2" />
    <path d="M8 0V11M0 5.5H16" stroke="white" strokeWidth="3" />
    <path d="M8 0V11M0 5.5H16" stroke="#C8102E" strokeWidth="1" />
    <path d="M0 0L16 11M16 0L0 11" stroke="#C8102E" strokeWidth="0.5" />
  </svg>
);

export default LangEnglishUKFlag;
